import { colors } from 'theme'

export const defaultThemeStyles: { [index: string]: string } = {
    background: colors.white,
}
